import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {
    weekDayList: [],
    doctor: [],
    area: [],
  },
  editData: [],
};

export const DoctorAvailabilityFormSlice = createSlice({
  name: "DoctorAvailabilityFormReducer",
  initialState,
  reducers: {
    setDoctorAvailabilityData: (state, action) => {
      state.editData = action.payload;
    },
    resetState: (state) => {
      state.editData = {};
    },
    setWeekDayList: (state, action) => {
      state.filters.weekDayList = action.payload;
    },
    setDoctorComboList: (state, action) => {
      state.filters.doctor = action.payload;
    },
    setAreaComboList: (state, action) => {
      state.filters.area = action.payload;
    },
  },
});

export const {
  setDoctorAvailabilityData,
  setWeekDayList,
  setDoctorComboList,
  setAreaComboList,
  resetState,
} = DoctorAvailabilityFormSlice.actions;

export default DoctorAvailabilityFormSlice.reducer;
